import * as types from "../types/auth";
import firebase from "../../firebase";



export const connectUser = (currentUser,provider)=>{
    return async dispatch=>{
        try{
            dispatch({type:types.CONNECT_USER})
            await firebase.firestore().collection('UserDataModel').limit(1)
                .where("walletAddress", '==', `${currentUser}`)
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const userDetail = doc.data();
                        dispatch({type:types.CONNECT_USER_SUCCESS,payload:{currentUser,provider,userDetail}})
                    });
                })
                .catch(function (error) {
                    dispatch({type:types.CONNECT_USER_FAILURE,payload:error.message})
                });
        }catch (error) {
            dispatch({type:types.CONNECT_USER_FAILURE,payload:error.message})
        }
    }
}

export const disconnectUser = ()=>{
    return async dispatch=>{
        try{
            dispatch({type:types.DISCONNECT_USER})
            dispatch({type:types.DISCONNECT_USER_SUCCESS})
        }catch (error) {
            dispatch({type:types.DISCONNECT_USER_FAILURE,payload:error.message})
        }
    }
}

export const openConnectModal = ()=>{
    return async dispatch =>{
        try {
            dispatch({type:types.OPEN_CONNECT_MODAL})
        }catch (e){
            console.log(e.message)
        }
    }
}

export const closeConnectModal = ()=>{
    return async dispatch =>{
        try {
            dispatch({type:types.CLOSE_CONNECT_MODAL})
        }catch (e){
            console.log(e.message)
        }
    }
}
export const likeCard = (docID,walletAddress)=>{
    return async dispatch=>{
        try{
            dispatch({type:types.LIKE_NFT})
            let nftRef =  firebase.firestore().collection('NFTDataModel').doc(`${docID}`);
            let userRef =  firebase.firestore().collection('UserDataModel').doc(`${walletAddress}`);
            nftRef.update({
                likes: firebase.firestore.FieldValue.increment(1),
                score: firebase.firestore.FieldValue.increment(4)
            }).then(data=>{
                userRef.update({
                    likedNft: firebase.firestore.FieldValue.arrayUnion(`${docID}`)
                }).then(data=>{
                    dispatch({type:types.LIKE_NFT_SUCCESS,payload:docID})
                }).catch(err=>{
                    dispatch({type:types.LIKE_NFT_FAILURE,payload:err.message})
                })
            }).catch(err=>{
                dispatch({type:types.LIKE_NFT_FAILURE,payload:err.message})
            })
        }catch (error) {
            dispatch({type:types.LIKE_REQUEST_FAILURE,payload:error.message})
        }
    }
}

export const dislikeCard = (docID,walletAddress)=>{
    return async dispatch=>{
        try{
            dispatch({type:types.DISLIKE_NFT})
            let nftRef = await firebase.firestore().collection('NFTDataModel').doc(`${docID}`);
            let userRef = await firebase.firestore().collection('UserDataModel').doc(`${walletAddress}`);
            nftRef.update({
                likes: firebase.firestore.FieldValue.increment(-1),
                score: firebase.firestore.FieldValue.increment(-4)
            }).then(data=>{
                userRef.update({
                    likedNft: firebase.firestore.FieldValue.arrayRemove(`${docID}`)
                }).then(data=>{
                    dispatch({type:types.DISLIKE_NFT_SUCCESS,payload:docID})
                }).catch(err=>{
                    dispatch({type:types.DISLIKE_NFT_FAILURE,payload:err.message})
                })
            }).catch(err=>{
                dispatch({type:types.DISLIKE_NFT_FAILURE,payload:err.message})
            })
        }catch (error) {
            dispatch({type:types.DISLIKE_NFT_FAILURE,payload:error.message})
        }
    }
}
export const fetchUser = (currentUser)=>{
    return async dispatch =>{
        try{
            dispatch({type:types.FETCH_USER})
            await firebase.firestore().collection('UserDataModel').limit(1)
                .where("walletAddress", '==', `${currentUser}`)
                .get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const userDetail = doc.data();
                        dispatch({type:types.FETCH_USER_SUCCESS,payload:userDetail})
                    });
                })
                .catch(function (error) {
                    dispatch({type:types.FETCH_USER_FAILURE,payload:error.message})
                });
        }catch (error) {
            dispatch({type:types.FETCH_USER_FAILURE,payload:error.message})
        }
    }
}